import { Component, OnInit, inject, viewChild } from "@angular/core";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { MatCheckboxChange, MatCheckbox } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { DataAccessService } from "../core/services/data-access.service";
import { ISimpleListElement } from "../core/models/ISimpleListElement";
import Swal from "sweetalert2";
import { UploadService } from "../core/services/upload-service";
import { HttpResponse } from "@angular/common/http";
import { IParam } from "../core/models/IParam";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MyLoaderComponent } from "../core/components/my-loader/my-loader.component";
import { MatCard } from "@angular/material/card";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatSelect, MatOption } from "@angular/material/select";
import { MatInput } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { HighlightSearchPipe } from "../highlighttable-search.pipe";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from "@angular/material/datepicker";
import { LfSelectSearchComponent } from "../core/components/lf-select-search/lf-select-search.component";

const initialSelection = [];
const allowMultiSelect = true;

@Component({
    selector: "app-parameters",
    templateUrl: "./parameters.component.html",
    styleUrls: ["./parameters.component.scss"],
    imports: [MatToolbar, MatToolbarRow, MatButton, MatIcon, MyLoaderComponent, MatCard, MatFormField, MatLabel, MatSelect, MatOption, MatTabGroup, MatTab, MatInput, FormsModule, MatCheckbox, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatSortHeader, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, HighlightSearchPipe]
})
export class ParametersComponent implements OnInit {
  dialog = inject(MatDialog);
  private dataAccess = inject(DataAccessService);
  private upload = inject(UploadService);

  displayedColumns: string[] = [
    "select",
    "cr_name",
    "gf_rate",
    "effective_date",
    "invalid_date",
    "last_update_dt",
    "last_update_user",
  ];
  displayedColumns2: string[] = [
    "select",
    "prtype_name",
    "category_name",
    "claim_name",
    "effective_date",
    "invalid_date",
    "last_update_dt",
    "last_update_user",
  ];

  dataSource: MatTableDataSource<IParam> = new MatTableDataSource<IParam>();

  readonly paginator1 = viewChild("pag1", { read: MatPaginator });
  readonly paginator2 = viewChild("pag2", { read: MatPaginator });
  readonly sort1 = viewChild("table1", { read: MatSort });
  readonly sort2 = viewChild("table2", { read: MatSort });
  readonly tabGroup = viewChild(MatTabGroup);

  selection = null;

  categories: ISimpleListElement[];

  categoryId: number;
  allowEdit: boolean;
  allowAdd: boolean;
  showInvalid: boolean;
  filterText = "";
  isSU: boolean;
  isBN: boolean;
  isPNESU: boolean;

  constructor() {
    this.selection = new SelectionModel<IParam>(
      allowMultiSelect,
      initialSelection
    );
    this.showInvalid = false;
    this.categoryId = 0;
  }

  async ngOnInit() {
    if (await this.dataAccess.haveAccessToModuleAsync("parameters")) {
      this.dataAccess
        .getJSONPost(
          "set_last_module",
          [],
          [{ k: "last_module", v: "parameters" }]
        )
        .then(() => {
          const su_roles = (this.dataAccess.getLoginData() as any).su_roles;
          this.isSU = su_roles
            ? su_roles.filter((x) => x.role === "SU").length > 0
            : false;
          this.isBN = su_roles
            ? su_roles.filter((x) => x.role === "BN").length > 0
            : false;
          this.isPNESU = su_roles
            ? su_roles.filter((x) => x.role === "PNESU").length > 0
            : false;

          this.dataAccess
            .getJSONPost("get_categories", [], [{ k: "p_module", v: "parameters" }])
            .then((data) => {
              this.categories = data;

              let defaultCategory = 0;

              if (this.categories && this.categories.length == 1) {
                defaultCategory = this.categories[0].id;
              }

              if (this.categories && this.categories.length > 1) {
                this.categories.unshift({ id: 0, name: "All" });
              }

              this.categoryId = defaultCategory;
            });

          this.refreshList();
        });
    } else {
      this.dataAccess.logout();
    }
  }

  refreshList() {
    const tabGroup = this.tabGroup();
    this.allowEdit =
      ((tabGroup.selectedIndex == 0 ||
        tabGroup.selectedIndex == undefined) &&
        this.isBN) ||
      (tabGroup.selectedIndex == 1 && (this.isPNESU || this.isSU));
    this.allowAdd =
      this.allowEdit &&
      (this.tabGroup().selectedIndex == 1 ? this.categoryId != 0 : true);

    this.selection.clear();

    let get_data = "";
    let params = [];

    // GFXR tab
    const tabGroupValue = this.tabGroup();
    if (
      tabGroupValue.selectedIndex == 0 ||
      tabGroupValue.selectedIndex == undefined
    ) {
      get_data = "get_currencies";
      params = [
        { k: "p_show_euro", v: false },
        { k: "p_show_invalid", v: this.showInvalid },
      ];
    }

    //CRC tab
    else if (tabGroupValue.selectedIndex == 1) {
      get_data = "get_claim_reason_codes";
      params = [
        { k: "p_category_id", v: this.categoryId },
        { k: "p_show_invalid", v: this.showInvalid },
      ];
    }

    this.dataAccess.getJSONPost(get_data, [], params).then((data) => {
      const tabGroupVal = this.tabGroup();
      if (
        tabGroupVal.selectedIndex == 0 ||
        tabGroupVal.selectedIndex == undefined
      ) {
        this.dataSource.sort = this.sort1();
        this.dataSource.paginator = this.paginator1();
      } else if (tabGroupVal.selectedIndex == 1) {
        this.dataSource.sort = this.sort2();
        this.dataSource.paginator = this.paginator2();
      }

      this.dataSource.sortingDataAccessor = (data, sortHeaderId) =>
        data[sortHeaderId]
          ? typeof data[sortHeaderId] === "string"
            ? data[sortHeaderId].toString().toLocaleLowerCase()
            : data[sortHeaderId]
          : null;
      this.dataSource.data = Array.isArray(data) ? data : [];
    });
  }

  selectedTabChange() {
    this.filterText = "";
    this.refreshList();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // selection of all the rows on the current page
  getPageData() {
    return this.dataSource._pageData(
      this.dataSource._orderData(this.dataSource.filteredData)
    );
  }

  isEntirePageSelected() {
    return this.getPageData().every((row) => this.selection.isSelected(row));
  }

  masterToggle(checkboxChange: MatCheckboxChange) {
    this.isEntirePageSelected()
      ? this.selection.deselect(...this.getPageData())
      : this.selection.select(...this.getPageData());
  }

  openAddDialog(): void {
    let component: any;

    const tabGroup = this.tabGroup();
    if (
      tabGroup.selectedIndex == 0 ||
      tabGroup.selectedIndex == undefined
    ) {
      component = EditGFARDialog;
    } else if (tabGroup.selectedIndex == 1) {
      if (this.categoryId == 0) {
        Swal.fire("Error!", "Select category first!", "error");
        return;
      }
      component = EditClaimReasonCodeDialog;
    }

    const dialogRef = this.dialog.open(component, {
      data: {
        selectedTabIndex: tabGroup.selectedIndex,
        categoryId: this.categoryId,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.refreshList();
    });
  }

  openEditDialog(pData: IParam = null): void {
    if (this.allowEdit) {
      let objectToEdit: IParam;
      let component: any;
      let params: object;

      if (pData) objectToEdit = pData;
      else objectToEdit = this.selection.selected[0];

      const tabGroup = this.tabGroup();
      if (tabGroup.selectedIndex == 0) {
        component = EditGFARDialog;
        params = {
          objectToEdit: objectToEdit,
        };
      } else if (tabGroup.selectedIndex == 1) {
        component = EditClaimReasonCodeDialog;
        params = {
          objectToEdit: objectToEdit,
          categoryId: this.categoryId,
        };
      }

      const dialogRef = this.dialog.open(component, { data: params });

      dialogRef.afterClosed().subscribe(() => {
        this.refreshList();
      });
    }
  }

  delete(): void {
    let remove_function = "";

    const tabGroup = this.tabGroup();
    if (
      tabGroup.selectedIndex == 0 ||
      tabGroup.selectedIndex == undefined
    ) {
      remove_function = "remove_currency";
    } else if (tabGroup.selectedIndex == 1) {
      remove_function = "remove_claim_reason_codes";
    }

    Swal.fire({
      title: "Warning",
      text: "Are you sure you want to set selected records as invalid?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        for (const s of this.selection.selected) {
          this.dataAccess
            .getJSONPost(remove_function, [], [{ k: "p_id", v: s.id }])
            .then((data) => {
              if (data.res != 0) {
                Swal.fire("Error!", data.msg, "error");
              } else {
                this.refreshList();
              }
            });
        }
      }
    });
  }

  export(): void {
    let export_function = "";
    let params = [];
    let filename = "";

    const tabGroup = this.tabGroup();
    if (
      tabGroup.selectedIndex == 0 ||
      tabGroup.selectedIndex == undefined
    ) {
      export_function = "export_currencies";
      params = [
        { k: "p_show_euro", v: false },
        { k: "p_show_invalid", v: this.showInvalid },
      ];
      filename = "gfxr";
    } else if (tabGroup.selectedIndex == 1) {
      export_function = "export_claim_reasons";
      params = [
        { k: "p_category_id", v: this.categoryId },
        { k: "p_show_invalid", v: this.showInvalid },
      ];
      filename = "claim_reasons";
    }

    window.open(
      this.dataAccess.getXLSUrlNoJSON(export_function, [], params, filename),
      "_blank",
      "location=yes"
    );
  }

  exportFailedRows(uploadId: number): void {
    window.open(
      this.dataAccess.getXLSUrl(
        "export_failed_rows",
        [],
        [{ k: "p_upload_id", v: uploadId }],
        "failed_to_upload"
      ),
      "_blank",
      "location=yes"
    );
  }

  showSelectFileDialog() {
    document.getElementById("fileUpload").click();
  }

  selectFile(event) {
    this.uploadFile(event.target.files);
    event.srcElement.value = null;
  }

  uploadFile(files: FileList) {
    if (files.length == 0) {
      return;
    }

    const file: File = files[0];

    let import_function = "";
    let params = [];

    const tabGroup = this.tabGroup();
    if (
      tabGroup.selectedIndex == 0 ||
      tabGroup.selectedIndex == undefined
    ) {
      if ((this.dataAccess.getLoginData() as any).is_admin)
        import_function = "migrate_currencies";
      else import_function = "import_currencies";
    } else if (tabGroup.selectedIndex == 1) {
      if ((this.dataAccess.getLoginData() as any).is_admin)
        import_function = "migrate_claim_reasons";
      else import_function = "import_claim_reasons";

      params = [{ k: "p_category_id", v: this.categoryId }];
    }

    const uploadURL = this.dataAccess.getXLSUploadUrl(
      import_function,
      [],
      params
    );

    this.upload.uploadFile(uploadURL, file).subscribe(
      (event) => {
        if (event instanceof HttpResponse) {
          if (!((event.body as any).res == 0)) {
            //Swal.fire("Error!", (event.body as any).msg, 'error');
            const uploadId = (event.body as any).reference;
            Swal.fire({
              title: "Error!",
              html: (event.body as any).msg,
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Download failed",
              showCancelButton: true,
            }).then((result) => {
              if (result.value) {
                this.exportFailedRows(uploadId);
              }
            });
            this.refreshList();
          } else {
            Swal.fire("Import complete!", (event.body as any).msg, "success");
            this.refreshList();
          }
        }
      },
      (err) => {
        Swal.fire("Error!", "Upload Error: " + err.statusText, "error");
      },
      () => {}
    );
  }

  checkRow(row) {
    if (this.selection.isSelected(row)) {
      this.selection.deselect(row);
    } else {
      this.selection.select(row);
    }
  }
}

@Component({
    selector: "edit-gfar-dialog",
    templateUrl: "edit-gfar-dialog.html",
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton]
})
export class EditGFARDialog implements OnInit {
  dialogRef = inject<MatDialogRef<EditGFARDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  currencies: ISimpleListElement[];
  gfar: IParam;
  caption: string;
  minDate: Date;

  constructor() {
    const data = this.data;

    this.gfar = (data as any).objectToEdit
      ? (data as any).objectToEdit
      : (new Object() as IParam);
    this.minDate = new Date();
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onOkClick(): void {
    if (!this.dataAccess.isValid(this.gfar.gf_rate, "double")) {
      Swal.fire("Error!", "Incorrect GFXR = rate format.", "error");
      return;
    }

    if (
      this.gfar.effective_date &&
      !this.dataAccess.isValid(this.gfar.effective_date, "date")
    ) {
      Swal.fire("Error!", "Incorrect effective date format.", "error");
      return;
    }

    if (
      this.gfar.invalid_date &&
      !this.dataAccess.isValid(this.gfar.invalid_date, "date")
    ) {
      Swal.fire("Error!", "Incorrect valid to date format.", "error");
      return;
    }

    this.dataAccess
      .getJSONPost(
        "save_currency",
        [],
        [
          { k: "p_id", v: this.gfar.id },
          { k: "p_name", v: this.gfar.cr_name },
          {
            k: "p_rate",
            v: this.gfar.gf_rate
              ? this.gfar.gf_rate.toString().replace(",", ".")
              : null,
          },
          {
            k: "p_effective_date",
            v: this.dataAccess.parseDate(new Date(this.gfar.effective_date)),
          },
          {
            k: "p_invalid_date",
            v: this.dataAccess.parseDate(new Date(this.gfar.invalid_date)),
          },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else {
          this.dialogRef.close();
        }
      });
  }
}

@Component({
    selector: "edit-claim-reason-code-dialog",
    templateUrl: "edit-claim-reason-code-dialog.html",
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, LfSelectSearchComponent, MatCheckbox, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton]
})
export class EditClaimReasonCodeDialog implements OnInit {
  dialogRef = inject<MatDialogRef<EditClaimReasonCodeDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  cr: IParam;
  product_types: ISimpleListElement[];
  categoryId: number;
  categoryLevel = false;
  minDate: Date;

  constructor() {
    const data = this.data;

    (this.cr = (data as any).objectToEdit
      ? (data as any).objectToEdit
      : (new Object() as IParam)),
      (this.categoryId = (data as any).categoryId);
    this.categoryLevel = this.cr.is_category_level;
    this.minDate = new Date();

    if (this.cr.effective_date == undefined) {
      this.cr.effective_date = new Date();
    }
  }

  ngOnInit() {
    // console.log(this.categoryId);
    // console.log(this.cr.category_id);
    this.dataAccess
      .getJSONPost(
        "get_product_types_simple_list",
        [],
        [
          {
            k: "p_category_id",
            v: this.categoryId > 0 ? this.categoryId : this.cr.category_id,
          },
        ]
      )
      .then((data) => {
        this.product_types = data;
      });
  }

  onProductTypeChanged(aValue: number) {
    this.cr.product_type_id = aValue;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onOkClick(): void {
    let valid = true;

    if (
      this.cr.effective_date &&
      !this.dataAccess.isValid(this.cr.effective_date, "date")
    ) {
      valid = false;
      Swal.fire("Error!", "Incorrect effective date format.", "error");
    }

    if (
      this.cr.invalid_date &&
      !this.dataAccess.isValid(this.cr.invalid_date, "date")
    ) {
      valid = false;
      Swal.fire("Error!", "Incorrect valid to date format.", "error");
    }

    if (valid) {
      this.dataAccess
        .getJSONPost(
          "save_claim_reason_codes",
          [],
          [
            { k: "p_id", v: this.cr.id },
            { k: "p_product_type_id", v: this.cr.product_type_id },
            { k: "p_category_id", v: this.categoryId },
            { k: "p_is_category_level", v: this.categoryLevel },
            { k: "p_name", v: this.cr.claim_name },
            {
              k: "p_effective_date",
              v: this.dataAccess.parseDate(new Date(this.cr.effective_date)),
            },
            {
              k: "p_invalid_date",
              v: this.dataAccess.parseDate(new Date(this.cr.invalid_date)),
            },
          ]
        )
        .then((data) => {
          if (data.res != 0) {
            Swal.fire("Error!", data.msg, "error");
          } else {
            this.dialogRef.close();
          }
        });
    }
  }
}
